const administrativeRoles = new Set(["owner", "admin"]);

export function canAdministerWorkspace(role: string) {
  return administrativeRoles.has(role);
}

export function canRenameWorkspaceMember(
  role: string,
  currentUserId: string | undefined,
  memberUserId: string,
) {
  return canAdministerWorkspace(role) || currentUserId === memberUserId;
}

export function canRemoveWorkspaceMember(role: string, memberRole: string) {
  return (
    canAdministerWorkspace(role) && (memberRole !== "owner" || role === "owner")
  );
}

export function isLastWorkspaceOwner(
  memberRole: string,
  memberRoles: readonly string[],
) {
  return (
    memberRole === "owner" &&
    memberRoles.filter((role) => role === "owner").length === 1
  );
}
